import LoadingButton, { type LoadingButtonProps } from './LoadingButton'

export {
  LoadingButton,
  type LoadingButtonProps
}

export default LoadingButton
